import { createBaseTrackModel } from '@jbrowse/core/pluggableElementTypes/models';
import TrackType from '@jbrowse/core/pluggableElementTypes/TrackType';
import configSchemaF from './configSchema';
export default function QuantitativeTrackF(pluginManager) {
    pluginManager.addTrackType(() => {
        const configSchema = configSchemaF(pluginManager);
        return new TrackType({
            name: 'QuantitativeTrack',
            displayName: 'Quantitative track',
            configSchema,
            stateModel: createBaseTrackModel(pluginManager, 'QuantitativeTrack', configSchema),
        });
    });
}
